__turbopack_context__.v({
  "content": "details-module-scss-module__Tr08nG__content",
  "details": "details-module-scss-module__Tr08nG__details",
  "responsive-image": "details-module-scss-module__Tr08nG__responsive-image",
  "scroll-anchor": "details-module-scss-module__Tr08nG__scroll-anchor",
  "summary": "details-module-scss-module__Tr08nG__summary",
  "summary-content": "details-module-scss-module__Tr08nG__summary-content",
  "summary-icon": "details-module-scss-module__Tr08nG__summary-icon",
  "summary-text": "details-module-scss-module__Tr08nG__summary-text",
  "summary-text-loading": "details-module-scss-module__Tr08nG__summary-text-loading",
  "text": "details-module-scss-module__Tr08nG__text",
});
